import { Bar } from 'vue-chartjs';
import {
  CHART_FONT_FAMILY,
  getAxisTheme,
  getTooltipTheme,
} from 'dashboard/helper/chartThemeHelper';

/**
 * Defaults are built per render, not frozen at import, because the axis colours
 * come from the brand tokens and those flip between light and dark. Chart.js
 * 2.9's own fallbacks (`#666` ticks, a near-black grid) were chosen for a white
 * page and measured 2.87:1 against the dark report card.
 */
const buildDefaults = () => {
  const axis = getAxisTheme();
  const ticks = {
    fontFamily: CHART_FONT_FAMILY,
    fontColor: axis.tick,
    fontSize: 11,
  };
  const gridLines = {
    drawOnChartArea: false,
    color: axis.grid,
    zeroLineColor: axis.zeroLine,
  };

  return {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
      labels: { fontFamily: CHART_FONT_FAMILY, fontColor: axis.tick },
    },
    animation: { duration: 0 },
    datasets: { bar: { barPercentage: 1.0 } },
    tooltips: getTooltipTheme(),
    scales: {
      xAxes: [{ ticks, gridLines }],
      yAxes: [{ ticks: { ...ticks, beginAtZero: true }, gridLines }],
    },
  };
};

export default {
  extends: Bar,
  props: {
    collection: {
      type: Object,
      default: () => ({}),
    },
    chartOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    // A Chart.js canvas is painted once. Without these the chart keeps whatever
    // data and colours it was first given — so a date-range change or a
    // light/dark switch left a stale canvas behind.
    collection() {
      this.draw();
    },
    chartOptions() {
      this.draw();
    },
  },
  mounted() {
    this.draw();
  },
  methods: {
    draw() {
      this.renderChart(this.collection, {
        ...buildDefaults(),
        ...this.chartOptions,
      });
    },
  },
};
